module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "roomChange"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v("原住房信息")]), _vm._v(" "), _c('div', {
    staticClass: "padding-20 bg-fff"
  }, [_c('div', {
    staticClass: "listBox"
  }, [_c('img', {
    staticClass: "thumbnail",
    attrs: {
      "src": _vm.Url + _vm.pageDate.photoUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mesList"
  }, [_c('div', {
    staticClass: "title color-333 font-size-14px margin-top-8"
  }, [_vm._v("姓名：" + _vm._s(_vm.pageDate.studentName))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("学号：" + _vm._s(_vm.pageDate.studentNo))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("学院：" + _vm._s(_vm.pageDate.college))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("当前年级：" + _vm._s(_vm.pageDate.classYear) + "级")]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("房间号：" + _vm._s(_vm.pageDate.roonName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "subTitle margin-top-20"
  }, [_vm._v("选择换房目标")]), _vm._v(" "), _c('div', {
    staticClass: "exchageRoom"
  }, [_c('div', [_c('div', {
    staticClass: "pickerBoxs"
  }, [_c('span', {
    staticClass: "font-size-14px"
  }, [_vm._v("选择楼栋")]), _vm._v(" "), _c('div', {
    staticClass: "dropdownBox"
  }, [_c('div', {
    staticClass: "dropdown font-size-14px",
    class: {
      'color-999': !_vm.buildData.value
    },
    attrs: {
      "id": "buildDropdown"
    }
  }, [_vm._v(_vm._s(_vm.buildData.name))]), _vm._v(" "), _c('img', {
    staticClass: "dropArrow",
    attrs: {
      "src": "static/images/arrow-right.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pickerBoxs"
  }, [_c('span', {
    staticClass: "font-size-14px"
  }, [_vm._v("选择房间")]), _vm._v(" "), _c('div', {
    staticClass: "dropdownBox"
  }, [_c('div', {
    staticClass: "dropdown font-size-14px",
    class: {
      'color-999': !_vm.roomData.value
    },
    attrs: {
      "id": "roomDropdown"
    }
  }, [_vm._v(_vm._s(_vm.roomData.name))]), _vm._v(" "), _c('img', {
    staticClass: "dropArrow",
    attrs: {
      "src": "static/images/arrow-right.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "quedingBtn",
    on: {
      "click": function($event) {
        return _vm.quedingBtn()
      }
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('div', {
    staticClass: "subTitle margin-top-20"
  }, [_vm._v("目标房间住宿情况")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.list.length > 0) ? _c('div', {
    staticClass: "grid bg-fff nopadding"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "gridWarp"
    }, [_c('div', {
      staticClass: "gridCell flex-basis-60"
    }, [_c('div', [_vm._v(_vm._s(item.bedName))])]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1"
    }, [_c('div', [_vm._v(_vm._s(item.studentName))])]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.studentNo)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1"
    }, [_c('div', [_vm._v(_vm._s(item.college))])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subTitle margin-top-20"
  }, [_vm._v("添加审批表照片")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "control-form"
  }, [_c('ul', {
    staticClass: "upload-imgs"
  }, [(_vm.imgLen >= 1 ? false : true) ? _c('li', [_c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    ref: "inputer",
    staticClass: "upload",
    attrs: {
      "capture": "camera",
      "name": "file",
      "type": "file",
      "accept": "image/jpg,image/jpeg,image/png,image/gif,image/bmp"
    },
    on: {
      "change": _vm.addImg
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "imgAdd",
    attrs: {
      "src": "static/images/imgAdd.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "margin-top-20"
  }, [_vm._v("点击上传")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.imgs), function(value, key) {
    return _c('li', {
      key: key
    }, [_c('p', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": _vm.getObjectURL(value)
      }
    }), _c('a', {
      staticClass: "close",
      on: {
        "click": function($event) {
          return _vm.delImg(key)
        }
      }
    }, [_vm._v("×")])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "subTitle margin-top-20"
  }, [_vm._v("换寝原因")]), _vm._v(" "), _c('div', {
    staticClass: "bg-fff"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textarea),
      expression: "textarea"
    }],
    staticClass: "HqTextarea font-size-28 color-999 full-width margin-top-10",
    attrs: {
      "elastic": "",
      "placeholder": "请填写换寝原因",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.textarea)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textarea = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subTitle margin-top-20"
  }, [_vm._v("添加学生手机号码")]), _vm._v(" "), _c('div', {
    staticClass: "bg-fff"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telPhone),
      expression: "telPhone"
    }],
    staticClass: "telPhone",
    attrs: {
      "type": "number",
      "placeholder": "请填写学生手机号",
      "name": "telPhone"
    },
    domProps: {
      "value": (_vm.telPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "footerBtn",
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("提交换寝")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid bg-appStyle color-fff"
  }, [_c('div', {
    staticClass: "gridWarp nopadding noborder"
  }, [_c('div', {
    staticClass: "gridCell flex-basis-60"
  }, [_vm._v("\n            床位\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1"
  }, [_vm._v("\n            姓名\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1"
  }, [_vm._v("\n            学号\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1"
  }, [_vm._v("\n            学院\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-414ab470"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/RoomChange.vue
// module id = 850
// module chunks = 1